import Axios from "../../../axios.js";
import {userApiConstants} from "../../../constants/ApiConstant";


export async function saveUser(params) {
    return Axios.post(userApiConstants.SAVE_USER, params);
}

export async function searchUser(params, page, size) {
    return Axios.post(userApiConstants.SEARCH_USERS + `?page=${page}&size=${size}`, params);
}

export async function approveUser(params) {
    return Axios.post(userApiConstants.APPROVE_USER, params);
}

export async function blockUser(params) {
    return Axios.post(userApiConstants.BLOCK_USER, params);
}

export async function fetchUserDetail(params) {
    return Axios.post(userApiConstants.USER_DETAIL, params);
}

export async function resetPassword(params) {
    return Axios.post(userApiConstants.RESET_PASSWORD, params);
}

// Reset a user's failed-login counter (unlock an account locked by too many
// wrong password attempts). Body: { userId, remarks }.
export async function resetLoginAttempts(params) {
    return Axios.post(userApiConstants.RESET_ATTEMPTS, params);
}
